// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ALhs66nPrZI2KVEPPO56{cursor:pointer;border:1px solid var(--interaction-neutral-normal);background:var(--background-primary-inverted-primary);width:256px;color:var(--content-primary-primary);border-radius:6px;justify-content:space-between;align-items:center;padding:4px 8px 4px 12px;display:flex}.ALhs66nPrZI2KVEPPO56:hover{border:1px solid var(--interaction-neutral-hovered)}.AxcIp4JsB8wU8kLeiqGQ{width:209px}.OYgiNEvRtK8CTYl2B76Z{color:var(--content-neutral-primary)}.HCkXUW5hEGrETRVMcUMh{align-items:center;display:flex}.BldEbgFYzkm685b4e_Km{margin-right:8px}.ydjbyyLx1oof1iNeN9cv{line-height:23px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ALhs66nPrZI2KVEPPO56`,
	"containerXs": `AxcIp4JsB8wU8kLeiqGQ`,
	"default": `OYgiNEvRtK8CTYl2B76Z`,
	"textBlock": `HCkXUW5hEGrETRVMcUMh`,
	"iconContainer": `BldEbgFYzkm685b4e_Km`,
	"text": `ydjbyyLx1oof1iNeN9cv`
};
export default ___CSS_LOADER_EXPORT___;
